// Simple pub/sub for inactive account signaling across the app
// ES module syntax
const listeners = new Set();

export function subscribeInactive(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function notifyInactive(payload = { reason: 'inactive' }) {
  for (const l of listeners) {
    try { l(payload); } catch {}
  }
}

export default { subscribeInactive, notifyInactive };
